var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { trpc } from 'root/src/client/v2/trpc/trpc';
const STALE_TIME_MS = 1000 * 10;
// Fetches a single drop for the redesign drop page via tRPC. Normal mode (`/e/:slug`) uses
// drops.getDrop; preview mode (`/drop-preview/:slug`, the sales proposal share link) uses
// drops.getDropPreview, which runs the same dropGetEvent handler in preview mode so an unpublished
// proposal draft is viewable by anyone with the link (the slug is the shared secret; private
// campaigns stay gated inside the handler). Both reuse the legacy DROP_GET_EVENT handler, so the data
// shape matches the legacy page. Optional auth.
//
// Both queries are always declared (rules of hooks) but only one is ever `enabled`, selected by
// `preview`; the default is normal mode, so `/e/` behaviour is byte-for-byte unchanged.
export const useDropEvent = (mnemonicId, preview = false) => {
    const hasId = Boolean(mnemonicId);
    const liveQuery = trpc.drops.getDrop.useQuery({ mnemonicId: mnemonicId !== null && mnemonicId !== void 0 ? mnemonicId : '' }, { enabled: hasId && !preview, staleTime: STALE_TIME_MS });
    const previewQuery = trpc.drops.getDropPreview.useQuery({ mnemonicId: mnemonicId !== null && mnemonicId !== void 0 ? mnemonicId : '' }, { enabled: hasId && preview, staleTime: STALE_TIME_MS });
    const query = preview ? previewQuery : liveQuery;
    // Stable identity matters here: this is threaded down into the memoized dares section and into
    // every dare card/row below it, so a fresh closure per render defeats those memos and re-runs the
    // whole per-card hook stack on any page-level render. React Query's own `refetch` is stable.
    const queryRefetch = query.refetch;
    const refetch = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield queryRefetch();
    }), [queryRefetch]);
    return {
        drop: query.data,
        isLoading: query.isLoading,
        isError: query.isError,
        refetch,
    };
};
